<div class="req-form">
    <div *ngFor="let control of udfForms.controls; index as i">
        <div>
            <div *ngIf="udfs[i].uDFIControlType==='Header'">
                <h5>{{udfs[i].uDFTitle}}</h5>
            </div>
            <div class="form-group" *ngIf="udfs[i].uDFIControlType==='Check Box'">
                <div class="form-check">
                    <input id="value{{i}}" type="checkbox" class="form-check-input" [formControl]="udfForms.controls[i]">
                    <label class="form-check-label" for="value{{i}}">{{udfs[i].uDFTitle}}</label>
                </div>
            </div>
            <div *ngIf="udfs[i].uDFIControlType==='HTML'">
                <div [innerHTML]="udfs[i].uDFThisHTMLOnly"></div>

            </div>

            <div class="form-group" *ngIf="udfs[i].uDFIControlType==='Textbox'">
                <label for="value{{i}}" class="control-label">{{udfs[i].uDFTitle}}</label>
                <input id="value{{i}}" type="text" class="form-control" [formControl]="udfForms.controls[i]">
            </div>
        </div>
        <!-- <input [formControl]="udfForms.controls[i]" /> -->
    </div>
    <form [formGroup]="initialsForm">
        <div class="row" style="margin-top: 20px;">
            <div class="col-auto">
                <input id="initials1" type="text" class="form-control" formControlName="initials1" style="width: 70px;">
                <div *ngIf="f.initials1.invalid && (f.initials1dirty || f.initials1.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.initials1.errors.required">Initials are required.</div>
                    <div *ngIf="f.initials1.errors.maxlength">Maximum is {{f.initials1.errors.maxlength.requiredLength}}
                        characters.</div>
                </div>
            </div>

            <div class="col">
                <span><span class="req-field"> * </span>Provide your initials to accept the terms above</span>
            </div>
        </div>
        <h5 style="margin-top: 15px;">Release of Liability</h5>
        <div [innerHTML]="campaign.step3HTMLWaiver"></div>
        <!-- <div>
            <p>
                <a href="./file" download>Click here to Download
                    Copy</a>
            </p>
        </div> -->
        <div class="row" style="margin-top: 20px;">
            <div class="col-auto">
                <input id="initials2" type="text" class="form-control" formControlName="initials2"
                    style="width: 70px;margin: 10px;">
                <div *ngIf="f.initials2.invalid && (f.initials2dirty || f.initials2.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.initials2.errors.required">Initials are required.</div>
                    <div *ngIf="f.initials2.errors.maxlength">Maximum is 4 characters.</div>
                </div>
            </div>
            <div class="col">
                <span><span class="req-field"> * </span>Initials. I hereby acknowledge that I have carefully read this entire
                    document, that I fully understand its
                    contents, that I am over the age of 18, that I am signing this document of my own free will
                    and without coercion, and that I intend for this document to be legally binding</span>
            </div>
        </div>
    </form>
</div>